import { BookOpen } from "lucide-react";
import { Link } from "react-router-dom";

const SectorGuides = () => (
  <section className="py-16 sm:py-28 bg-secondary">
    <div className="container max-w-6xl px-5 sm:px-6 lg:px-8">
      <p className="section-label mb-4">Sector Guides</p>
      <div className="teal-rule mb-6" />
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div className="max-w-3xl">
          <h2 className="text-3xl sm:text-4xl text-foreground mb-4">Advertising compliance guidance for your sector</h2>
          <p className="text-text-body text-lg leading-relaxed">Practical reference guides for supplements, pharmacies, telehealth, medical devices, clinics, allied health, dental practices, and functional foods.</p>
        </div>
        <Link to="/guides" className="inline-flex items-center gap-2 text-primary font-semibold shrink-0"><BookOpen className="h-5 w-5" />Explore Sector Guides →</Link>
      </div>
    </div>
  </section>
);

export default SectorGuides;